export default __webpack_public_path__ + "static/media/top.9c5d9035.png";